import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function regReducer(state = initialState.registration, action) {
  let newState;

  switch (action.type) {
    case types.LOAD_REG_DETAILS:
      newState = objectAssign({}, state, {loading: true});
      newState.details = {};
      newState.detailsUpdated = Date.now();
      return newState;

    case types.LOAD_REG_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.details = action.details;
      newState.detailsUpdated = action.detailsUpdated;
      return newState;

    case types.LOAD_REG_REVIEW_DETAILS:
      newState = objectAssign({}, state, {loading: true});
      newState.reviewDetails = {};
      newState.reviewDetailsUpdated = Date.now();
      return newState;

    case types.LOAD_REG_REVIEW_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.reviewDetails = action.details;
      newState.reviewDetailsUpdated = action.detailsUpdated;
      return newState;

    case types.LOAD_REG_DETAILS_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.errors = action.errors;
      newState.detailsUpdated = action.detailsUpdated;
      return newState;

    case types.SAVE_REG:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.UPDATE_REG_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.details = action.details;
      newState.detailsUpdated = action.detailsUpdated;
      return newState;

    case types.CREATE_REG_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.details = action.details;
      newState.detailsUpdated = action.detailsUpdated;
      return newState;

    case types.UPDATE_REG_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.errors = action.errors;
      return newState;

    case types.LOAD_TEAM_LIST:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.LOAD_TEAM_LIST_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.teamList = action.teamList;
      newState.teamListUpdated = action.teamListUpdated;
      return newState;

    case types.SAVE_TEAM_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.teamList = action.teamList;
      newState.teamListUpdated = action.teamListUpdated;
      return newState;

    case types.SAVE_TEAM_FAILURE:
      newState = objectAssign({}, state, {loading: false});
      newState.teamErrors = action.teamErrors;
      return newState;

    case types.LOAD_APPROVED_REG_LIST:
      newState = objectAssign({}, state, {loading: true});
      return newState;

    case types.LOAD_APPROVED_REG_LIST_SUCCESS:
      newState = objectAssign({}, state, {loading: false});
      newState.approvedRegList = action.approvedRegList;
      newState.approvedRegListUpdated = action.approvedRegListUpdated;
      return newState;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/regReducer.js
 **/